var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1208 3.3497C15.3256 2.8613 16.6731 2.8613 17.8779 3.3497L27.876 7.40299C28.7565 7.75997 29.3327 8.61523 29.3327 9.56539V22.4357C29.3327 23.3858 28.7565 24.2411 27.876 24.5981L17.8779 28.6513C16.6731 29.1397 15.3256 29.1397 14.1208 28.6513L4.1227 24.5981C3.24216 24.2411 2.66602 23.3858 2.66602 22.4357V9.56539C2.66602 8.61523 3.24216 7.75997 4.1227 7.40299L14.1208 3.3497ZM17.1265 5.20318C16.4036 4.91014 15.5951 4.91014 14.8722 5.20318L12.3206 6.23761L22.3564 10.1404L25.9154 8.76625L17.1265 5.20318ZM19.5875 11.2095L9.61898 7.33288L6.11973 8.75149L16.0011 12.5943L19.5875 11.2095ZM4.66602 22.4357C4.66602 22.5714 4.74832 22.6936 4.87411 22.7446L14.8722 26.7979C14.9145 26.815 14.957 26.8311 14.9998 26.8462V14.3508L4.66602 10.3321V22.4357ZM17.1265 26.7979L27.1246 22.7446C27.2504 22.6936 27.3327 22.5714 27.3327 22.4357V10.3629L16.9998 14.3525V26.8459C17.0423 26.8309 17.0845 26.8149 17.1265 26.7979Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackaging);
export default __webpack_public_path__ + "static/media/Packaging.9cebe86b89acca6ffdd599036f65e0de.svg";
export { ForwardRef as ReactComponent };